var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"welcome"}},[_c('div',{attrs:{"id":"bk"}},[_vm._v("欢迎访问影院管理后台")])])
}]

export { render, staticRenderFns }